
          import "Primary_1qfbe2.linaria.css";
          import { styled } from "@linaria/react";
import { focusStyle } from "@carvana/showroom-css-theme";
import Button from "./Base";
export default /*#__PURE__*/styled(Button)({
  name: "Primary0",
  class: "p1234149"
});
          